module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "full-header"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "down",
    attrs: {
      "href": "#our-services"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showServices()
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section featured-projects"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.features), function(project) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4"
    }, [_c('project-preview', {
      attrs: {
        "project": project
      }
    })], 1)
  }))])])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-text"
  }, [_c('h1', [_vm._v("Hi. We’re Label.")]), _vm._v(" "), _c('h1', [_vm._v("We create world class apps & websites.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section our-services",
    attrs: {
      "id": "our-services"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "section-heading"
  }, [_vm._v("our services")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3"
  }, [_c('img', {
    staticClass: "svg ui",
    attrs: {
      "src": require("assets/images/home_services_ui.svg"),
      "alt": "UI / UX Work Services."
    }
  }), _vm._v(" "), _c('h3', [_vm._v("UI / UX")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3"
  }, [_c('img', {
    staticClass: "svg web",
    attrs: {
      "src": require("assets/images/home_services_web.svg"),
      "alt": "Web Design Services."
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Digital Design")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3"
  }, [_c('img', {
    staticClass: "svg dev",
    attrs: {
      "src": require("assets/images/home_services_dev.svg"),
      "alt": "Development Services."
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Development")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-3"
  }, [_c('img', {
    staticClass: "svg integ",
    attrs: {
      "src": require("assets/images/home_services_integ.svg"),
      "alt": "Integration Services."
    }
  }), _vm._v(" "), _c('h3', [_vm._v("App Development")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "section-heading"
  }, [_vm._v("featured projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section our-clients"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "section-heading"
  }, [_vm._v("some of our clients")]), _vm._v(" "), _c('img', {
    staticClass: "clients img-responsive",
    attrs: {
      "src": require("assets/images/label_portfolio@2x.png"),
      "alt": "List of our clients."
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41cf7906!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 587
// module chunks = 2